import * as types from "@/store/types";

const state = {
  modalStep: 1,
  isModalOpen: false
};

const getters = {
  [types.email.getters.IS_MODAL_OPEN]: state => {
    return state.isModalOpen;
  },
  [types.email.getters.MODAL_STEP]: state => {
    return state.modalStep;
  }
};

const mutations = {
  [types.email.mutations.MUTATE_STEP]: (state, payload) => {
    state.modalStep = payload;
  },
  [types.email.mutations.MUTATE_MODAL]: (state, payload) => {
    state.isModalOpen = payload;
  }
};

const actions = {
  [types.email.actions.SET_STEP]: ({ commit }, payload) => {
    commit(types.email.mutations.MUTATE_STEP, payload);
  },
  [types.email.actions.SET_MODAL]: ({ commit }, payload) => {
    commit(types.email.mutations.MUTATE_MODAL, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
